export const normalizePhoneForSearch = (value = ''): string => {
  let digits = value.replace(/\D/g, '');
  if (digits.startsWith('00')) digits = digits.slice(2);
  if (digits.startsWith('0')) digits = `44${digits.slice(1)}`;
  return digits;
};

export const phoneMatchesSearch = (phone = '', query = ''): boolean => {
  const normalizedQuery = normalizePhoneForSearch(query);
  return normalizedQuery.length >= 3 && normalizePhoneForSearch(phone).includes(normalizedQuery);
};
